import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-storage-warning',
  templateUrl: './storage-warning.component.html',
  styleUrls: ['./storage-warning.component.scss'],
  standalone: false,
})
export class StorageWarningComponent implements OnInit {
  displayWarning = false;
  messageParams: {};

  constructor() {}

  async ngOnInit(): Promise<void> {
    if (typeof navigator.storage !== 'undefined') {
      const estimate = await navigator.storage.estimate();
      const usage = (estimate.usage * 100) / estimate.quota;
      this.messageParams = { usage: usage.toFixed(2) };
      this.displayWarning = usage >= 90;
    }
  }
}
